"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsApphiveEnviroment_1 = __importDefault(require("./valueIsApphiveEnviroment"));
const valueIsRecord_1 = __importDefault(require("./valueIsRecord"));
const valueIsReposConfigServicesUrls_1 = __importDefault(require("./valueIsReposConfigServicesUrls"));
const valueIsString_1 = __importDefault(require("./valueIsString"));
const valueIsUndefined_1 = __importDefault(require("./valueIsUndefined"));
const valueIsClientConfig = (value) => {
    if (!(0, valueIsRecord_1.default)(value)) {
        throw new Error('[ClientConfig] value should be a record');
    }
    if (!(0, valueIsApphiveEnviroment_1.default)(value.environment)) {
        throw new Error('[ClientConfig] invalid environment');
    }
    if (!(0, valueIsRecord_1.default)(value.servicesUrls)) {
        throw new Error('[ClientConfig] value.servicesUrls should be a record');
    }
    if (!(0, valueIsReposConfigServicesUrls_1.default)(value.servicesUrls.DEVELOPMENT)) {
        throw new Error('[ClientConfig] invalid dev services urls');
    }
    if (!(0, valueIsReposConfigServicesUrls_1.default)(value.servicesUrls.STAGING)) {
        throw new Error('[ClientConfig] invalid staging services urls');
    }
    if (!(0, valueIsReposConfigServicesUrls_1.default)(value.servicesUrls.PRODUCTION)) {
        throw new Error('[ClientConfig] invalid production services urls');
    }
    if (!(0, valueIsRecord_1.default)(value.stripeClientKeys)) {
        throw new Error('[ClientConfig] stripeClientKeys should be a record');
    }
    if (!(0, valueIsString_1.default)(value.stripeClientKeys.DEVELOPMENT)) {
        throw new Error('[ClientConfig] stripeClientKeys.DEVELOPMENT should be a string');
    }
    if (!(0, valueIsString_1.default)(value.stripeClientKeys.STAGING)) {
        throw new Error('[ClientConfig] stripeClientKeys.STAGING should be a string');
    }
    if (!(0, valueIsString_1.default)(value.stripeClientKeys.PRODUCTION)) {
        throw new Error('[ClientConfig] stripeClientKeys.PRODUCTION should be a string');
    }
    if (!(0, valueIsRecord_1.default)(value.firebaseWebClient) && !(0, valueIsUndefined_1.default)(value.firebaseWebClient)) {
        throw new Error('[ClientConfig] value.firebaseWebClient should be a record or undefined');
    }
    if (value.firebaseWebClient && !(0, valueIsRecord_1.default)(value.firebaseWebClient.DEVELOPMENT)) {
        throw new Error('[ClientConfig] value.firebaseWebClient.DEVELOPMENT should be a record');
    }
    if (value.firebaseWebClient && !(0, valueIsRecord_1.default)(value.firebaseWebClient.STAGING)) {
        throw new Error('[ClientConfig] value.firebaseWebClient.DEVELOPMENT should be a record');
    }
    if (value.firebaseWebClient && !(0, valueIsRecord_1.default)(value.firebaseWebClient.PRODUCTION)) {
        throw new Error('[ClientConfig] value.firebaseWebClient.DEVELOPMENT should be a record');
    }
    return true;
};
exports.default = valueIsClientConfig;
